module.exports = __webpack_public_path__ + "assets/images/EURUNFIT5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EURUNFIT5.png
// module id = 1376
// module chunks = 1